function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawBeforeDawn = function UndrawBeforeDawn(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1161.12 729.37",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 600,
    y1: 813.84,
    x2: 600,
    y2: 85.32,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.2
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), React.createElement("path", {
    d: "M1079.66 477.61a121.55 121.55 0 0 0 3.26 94.61c.83 1.77 1.72 3.56 2.63 5.35 10.83 21.22 25.93 43.28 17.76 65.09-6.35 17-24.61 25.94-41.48 32.61a756.23 756.23 0 0 1-204 49.4c-51.6 5.09-103.57 4.84-155.43 4.58-112.15-.55-224.42-1.1-336.22-10-51.11-4-102.4-9.87-151.57-24.38A443.38 443.38 0 0 1 34.39 590.51c-1.82-1.73-3.61-3.49-5.39-5.28-10.72-10.81-20.5-22.78-25.44-37.09-9.8-28.66 1.95-60.15 17.06-86.41s34.07-51.31 40.24-81c9.11-43.71-11.16-87.39-26.74-129.23s-25.82-92.07-.05-128.53c12.57-17.78 32-29.39 51.55-39a441.87 441.87 0 0 1 185.14-45.13c37.45-.78 76.23 3 111.24-10.32C401.71 21 419.43 8.28 439.93 3.26c34.65-8.46 70.52 6.49 101.6 24 17.88 10.08 35.3 21.1 54 29.72 13.59 6.27 29.22 13.29 43.68 17.18 14.17 3.81 28.77-3.83 41.21-10.1 27-13.62 52.38-33.92 83.44-37.12 39.33-4 78.29 21.37 117 13.24 16.5-3.47 31.15-12.79 47.21-17.92 42-13.44 87.43 3 127.14 22.25 24.61 11.92 49.62 25.84 65 48.47 11.78 17.37 16.78 38.33 21.51 58.77 18 77.79 34.43 163.84-3.74 234-17.42 31.93-45.14 57.98-58.32 91.86z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1173.21 430a179.58 179.58 0 0 1-15.85 40.16c-17.38 31.93-45.08 58-58.26 91.89a115.81 115.81 0 0 0-4.78 15.44q-.78 3.24-1.35 6.52a121.58 121.58 0 0 0 9.39 72.66c.83 1.77 1.72 3.56 2.63 5.35 10.83 21.22 25.93 43.28 17.76 65.09a35.21 35.21 0 0 1-3.1 6.31c-8 13-23.73 20.51-38.38 26.3a756.23 756.23 0 0 1-204 49.4c-13.49 1.33-27 2.3-40.52 3-38.22 2-76.58 1.78-114.88 1.59-112.15-.55-224.42-1.1-336.22-10-51.11-4-102.4-9.87-151.57-24.38A443.38 443.38 0 0 1 53.83 675c-1.82-1.73-3.61-3.49-5.39-5.28-10.72-10.82-20.5-22.79-25.44-37.1-6.76-19.8-3.26-40.94 4.54-60.77a193.12 193.12 0 0 1 12.52-25.64c1.3-2.25 2.63-4.51 4-6.74 14.3-23.86 30.62-47.11 36.26-74.23 7-33.45-3.27-66.89-15.43-99.5-1.07-2.87-2.16-5.74-3.25-8.59-2.7-7.09-5.44-14.15-8.05-21.15-15.59-41.83-25.82-92.06-.05-128.52.71-1 1.46-2 2.23-3 12-15.42 29.32-26 46.93-34.83l2.39-1.2a441.87 441.87 0 0 1 185.14-45.13c37.45-.78 76.23 3 111.24-10.32 19.71-7.52 37.43-20.24 57.93-25.26 34.65-8.46 70.52 6.49 101.6 24 17.88 10.07 35.3 21.1 54 29.72 13.59 6.27 29.22 13.29 43.68 17.18 14.17 3.81 28.77-3.83 41.21-10.1 27-13.62 52.38-33.92 83.44-37.12 39.33-4 78.29 21.37 117 13.24 16.5-3.47 31.15-12.79 47.21-17.92 42-13.45 87.43 3 127.14 22.25 21.65 10.48 43.61 22.52 59 40.68a90.77 90.77 0 0 1 5.93 7.79c.21.3.41.61.61.92 11.34 17.18 16.26 37.76 20.9 57.85 9.08 39.24 17.77 80.58 19.24 120.93.89 24.91-.95 49.45-7.15 72.84z",
    transform: "translate(-19.44 -85.32)",
    fill: "url(#prefix__a)"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M1103.31 641.82a35.21 35.21 0 0 1-3.1 6.31 646.9 646.9 0 0 1-176.23 60c-34.32 6.4-70.07 12.7-106.69 18.67-38.22 2-76.58 1.78-114.88 1.59-112.15-.55-224.42-1.1-336.22-10-51.11-4-102.4-9.87-151.57-24.38A443.38 443.38 0 0 1 34.39 589.68c-1.82-1.73-3.61-3.49-5.39-5.28-10.72-10.82-20.5-22.79-25.44-37.1C-3.2 527.5.3 506.36 8.1 486.53l1065.46 12.15a121.58 121.58 0 0 0 9.39 72.66c.83 1.77 1.72 3.56 2.63 5.35 10.8 21.26 25.9 43.32 17.73 65.13zM1114.22 84.34H83.26l2.39-1.2a441.87 441.87 0 0 1 185.14-45.13c37.45-.78 76.23 3 111.24-10.32 19.71-7.52 37.43-20.24 57.93-25.26 34.65-8.46 70.52 6.49 101.6 24 17.88 10.07 35.3 21.1 54 29.72 13.59 6.27 29.22 13.29 43.68 17.18 14.17 3.81 28.77-3.83 41.21-10.1 27-13.62 52.38-33.92 83.44-37.12 39.33-4 78.29 21.37 117 13.24 16.5-3.47 31.15-12.79 47.21-17.92 42-13.45 87.43 3 127.14 22.25 21.6 10.46 43.56 22.5 58.98 40.66zM45.46 280.42c12.16 32.61 22.4 66.05 15.43 99.5-5.64 27.12-22 50.37-36.26 74.23l1050.25 38a115.81 115.81 0 0 1 4.78-15.44c13.18-33.87 40.88-60 58.26-91.89a179.58 179.58 0 0 0 15.85-40.14zm421.7 119.83h-26.6a13.19 13.19 0 1 1 0 26.37h-154a13.19 13.19 0 1 1 0-26.37h26.62a13.19 13.19 0 1 1 0-26.37h-19a13.18 13.18 0 1 1 0-26.36h154a13.18 13.18 0 1 1 0 26.36h19a13.19 13.19 0 1 1 0 26.37zM1141.66 150.9c-4.64-20.09-9.56-40.67-20.9-57.85L36.33 119.17c-.77 1-1.52 2-2.23 3-25.77 36.45-15.54 86.68.05 128.51 2.61 7 5.35 14.05 8.06 21.14H1160.9c-1.47-40.34-10.16-81.68-19.24-120.92zm-909.39 50.9h-26.61a13.19 13.19 0 1 1 0 26.37h-154a13.19 13.19 0 1 1 0-26.37h26.6a13.19 13.19 0 1 1 0-26.37h-19a13.18 13.18 0 1 1 0-26.36h154a13.18 13.18 0 1 1 0 26.36h19a13.19 13.19 0 1 1 0 26.37z"
  })), React.createElement("path", {
    d: "M1103.31 642.68c-6.35 17-24.61 25.94-41.48 32.61a756.23 756.23 0 0 1-204 49.4c-51.6 5.09-103.57 4.84-155.43 4.58-112.15-.55-224.42-1.1-336.22-10-51.11-4-102.4-9.87-151.57-24.38A443.38 443.38 0 0 1 34.39 590.51c-1.82-1.73-3.61-3.49-5.39-5.28a230.87 230.87 0 0 1 46.19-1.22c43.21 2.95 85.31 14.95 128.32 20.16 166.52 20.12 337.24-62.18 499.86-21.06 50.19 12.7 97.72 36.92 149.27 41.78 76.09 7.18 148.82-28.39 223.36-45.34 3.13-.72 6.33-1.39 9.55-2 10.83 21.24 25.93 43.3 17.76 65.13z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M897.79 290.45h5.13v283.08h-5.13zM907.8 626.48a13.41 13.41 0 0 1-16.44 0c-2.29-15.15 3.53-44.93 4.9-51.6.19-.87.29-1.35.29-1.35h6.58a4.78 4.78 0 0 1 1 1.54c4.57 9.68 3.67 51.41 3.67 51.41z"
  }), React.createElement("path", {
    d: "M901.78 567.41v6.12H899v-6.13a8.58 8.58 0 0 1 1.35-.1 9.52 9.52 0 0 1 1.43.11zM904.15 575.07a7.85 7.85 0 0 1-3.8.89 7.65 7.65 0 0 1-4.09-1.08c.19-.87.29-1.35.29-1.35h6.58a4.78 4.78 0 0 1 1.02 1.54z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 900.36,
    cy: 571.63,
    rx: 5.54,
    ry: 3.29,
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M876 244.85l19.19-8.11 29.09 5.65-22.32-16.88L876 244.85z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M881.71 247.84l-5.71-2.99 19.51-9.34 28.77 6.88-5.06 2.46-23.71-5.32-13.8 8.31z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M881.71 247.84l-5.71-2.99 20.08-10.22 28.2 7.76-5.06 2.46-23.71-5.32-13.8 8.31z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M880.94 245.63l15.7 44h7.78l14.54-46.72-23.45-5.46-14.57 8.18z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M908.28 277.24l-3.11 9.98-.75 2.41h-7.78l-.58-1.63-3.67-10.28 5.89-3.54 10 3.06z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M895.51 239.53l3.72 50.1h-2.59l-14.93-41.79 13.8-8.31z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M901.96 225.51l-6.45 10-19.51 9.34 25.96-19.34zM905.17 287.22l-.75 2.41h-7.78l-.58-1.63a6.49 6.49 0 0 1 5-1.88 7.51 7.51 0 0 1 4.11 1.1zM901.78 290.45v4.28a5.85 5.85 0 0 1-.73 0 8.93 8.93 0 0 1-2-.24v-4.08z"
  }), React.createElement("ellipse", {
    cx: 901.05,
    cy: 290.45,
    rx: 5.54,
    ry: 3.29,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M652.22 577.95s-66.66-2.81-73.66-133.27 62.43-152.56 62.43-152.56 22-12.29 31.75-12.8 42.36 2.57 42.36 2.57l-35.94-6.94s50.58-19.25 65.72-20.79l-54.67 11.52s-.77-30.29 12.32-40.31c0 0-11.16-.83-17.11 21a41.71 41.71 0 0 1-25 28c-20.29 7.91-48.33 20.4-54.71 31.09 0 0-11.81 12.33-10-19.76s10.27-59.57 13.35-60.34c0 0 24.14-25.67 58-27.21 0 0-19.76-8-53.14 16.95 0 0-2.82-12.58 9.76-27.47s32.09-46.22 53.4-49.55c0 0-29.78-1.8-53.4 36.71 0 0-8.73 5.65-9.5-8.73s-5.91-32.35-5.91-32.35-7.19 33.12 8 48c0 0-29 37.74-27.72 80.1 0 0-9 19.26-12.33-3.34 0 0-1.93-31.11-5.79-57.5a78.16 78.16 0 0 1 16.39-60.29c6.41-8 10.88-15.74 8.4-19.81l-33.63 40s-28.24-65.47-48.78-79.59-23.11-17.2-23.11-17.2l33.12 38.76-41.59-14.63 41.59 19.26s19.26 15.66 30.3 58.53 12.06 69.68 12.06 69.68-59.3-47-70.6-45.44l38.38 29a91.4 91.4 0 0 1 36.07 66.73s-74.19-19-92.16-22.59l-33.89-34.66 25.67 32.86-52.88-.77-30.3-21.56s23.88 20 21.57 21.31-37.23 2.82-37.23 2.82 88.83-.51 98.59 5.91 31.57 8.72 31.57 8.72l-62.9 9.5 75-5.39s56.74 10.27 59.82 28c0 0-11.56 30.14-19.26 42.1-6.39 9.93-19.25 42.1-21.82 70.34s-6.16 71.63 3.6 98.07 13.34 41.59 8.47 49.55-9.5 18.23 6.42 20.28 85.74-1 85.74-1 21.29 4.22 17.18-11.51z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M614.9 563.94a33.51 33.51 0 0 0-22.62-2.83c-13.08 2.83-33.1 1.33-34.93 1M573.07 410.2s-3.18 50.19 2.48 60.08zM561.33 470.28s4.08 47 6.9 56.19-6.9-56.19-6.9-56.19zM557.35 354.68c-2.88 1.06-15.25 26.15-12.78 33.57s12.78-33.57 12.78-33.57zM588.72 328.68c-1.35.61-7.1 15.06-5.95 19.34s5.95-19.34 5.95-19.34zM535.16 412.95c1.42 14.57 2.2 24.11 1.29 35.77a138.83 138.83 0 0 0 .39 27.22M690.04 243.26a11.71 11.71 0 0 0-2.41 7.39c-.09 2.64.26 5.29.08 7.92-.18 2.78-1.5 6-4.25 6.4M642.63 156.38a67 67 0 0 0-9.29 11.53 26.62 26.62 0 0 1-2.64 3.75 42.62 42.62 0 0 1-5.09 4.17 24 24 0 0 0-8.12 12.74M508.43 81.36a16.55 16.55 0 0 0 3.29 4.41c1.17 1.11 2.49 2 3.55 3.25a27.36 27.36 0 0 1 2.27 3.35 91.88 91.88 0 0 0 9.49 12M570.56 155.68c-2.21 1.38-2.79 4.34-2.74 7s.49 5.32-.48 7.74c-.44 1.11-1.15 2.08-1.61 3.17a14.78 14.78 0 0 0-.77 6q.06 3.56.22 7.09c.12 2.85.39 5.93 2.32 8",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M551.98 229.29a30.51 30.51 0 0 1 5.76 4 10.36 10.36 0 0 1 3.35 6c.13 1 .06 2 .28 3a9.4 9.4 0 0 0 2 3.61 49.59 49.59 0 0 0 4.86 5.38",
    fill: "none"
  }), React.createElement("path", {
    d: "M568.75 296.31a36.31 36.31 0 0 0-4.65-3.22 19.42 19.42 0 0 0-4.78-2.1c-2.56-.68-5.25-.58-7.88-.85s-5.39-1-7.19-2.95M464.36 263.88c3.12.09 6.37.2 9.14 1.63 1.42.73 2.65 1.77 4.05 2.55a12.26 12.26 0 0 0 5.89 1.54M507.67 276.77a1.74 1.74 0 0 0-2.24.52c-.56.64-.87 1.47-1.44 2.1-1.14 1.23-3 1.37-4.68 1.43M525.56 210.42l3 1.57a52.61 52.61 0 0 1 8.85 5.4M559.83 239.77c2-.47 3.68 1.64 4 3.63s-.06 4.1.51 6a11.25 11.25 0 0 0 3 4.44M593.23 243.44c1.79 5.36-2 11.21-.9 16.75.34 1.69 1.12 3.26 1.52 4.93 1 4.41-.75 9.11-3.63 12.61",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M293.43 623.09l1.54 3.28v-24.36h-1.54v21.08zM194.15 623.09l-1.54 3.28v-24.36h1.54v21.08zM200.36 557.25h4.26v29.95h-4.26zM286.04 557.25h4.26v29.95h-4.26z"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M200.36 557.25h4.26v29.95h-4.26zM286.04 557.25h4.26v29.95h-4.26z"
  })), React.createElement("path", {
    opacity: 0.1,
    d: "M200.36 557.25h4.26v3.49h-4.26zM286.04 557.25h4.26v3.49h-4.26z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M193.8 555.99h102.57v4.47H193.8z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M200.36 562.35h4.26v4.47h-4.26zM286.04 562.35h4.26v4.47h-4.26z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M193.8 562.07h102.57v4.47H193.8z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M200.36 568.42h4.26v4.47h-4.26zM286.04 568.42h4.26v4.47h-4.26z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M193.8 568.14h102.57v4.47H193.8z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M200.36 574.5h4.26v4.47h-4.26zM286.04 574.5h4.26v4.47h-4.26z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M193.8 574.22h102.57v4.47H193.8z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M200.36 580.57h4.26v4.47h-4.26zM286.04 580.57h4.26v4.47h-4.26z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M193.8 580.29h102.57v4.47H193.8z"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("circle", {
    cx: 202.49,
    cy: 558.51,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 564.58,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 570.66,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 576.73,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 582.81,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 558.51,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 564.58,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 570.66,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 576.73,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 582.81,
    r: 0.62
  })), React.createElement("circle", {
    cx: 202.49,
    cy: 558.23,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 564.3,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 570.38,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 576.45,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 582.53,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 558.23,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 564.3,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 570.38,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 576.45,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 582.53,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 558.23,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 564.3,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 570.38,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 576.45,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 582.53,
    r: 0.62,
    fill: "#3f3d56"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("circle", {
    cx: 202.49,
    cy: 558.23,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 564.3,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 570.38,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 576.45,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 582.53,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 558.23,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 564.3,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 570.38,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 576.45,
    r: 0.62
  }), React.createElement("circle", {
    cx: 202.49,
    cy: 582.53,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 558.23,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 564.3,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 570.38,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 576.45,
    r: 0.62
  }), React.createElement("circle", {
    cx: 288.17,
    cy: 582.53,
    r: 0.62
  })), React.createElement("path", {
    fill: "#3f3d56",
    d: "M298.74 588.95H191.35l2.45-3h102.56l2.38 3zM302.51 593.63l-115.21-.28 3.91-4.12h107.95l3.35 4.4zM306.14 598.03H183.18l3.77-4.26 115.84.14 3.35 4.12zM201.87 602.01v8.79l-1.51 2.94-.5-10.48-.06-1.25h2.07zM288.12 602.01l-.06 1.25-.5 10.48-1.51-2.94v-8.79h2.07z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M196.45 601.31h3.91v12.43h-3.91zM287.57 601.31h3.91v12.43h-3.91z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M200.36 602.01h1.51v1.25h-5.42v-1.95h3.91v.7z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M196.45 601.31h3.91v12.43h-3.91zM287.57 601.31h3.91v12.43h-3.91z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M291.48 601.31v1.95h-5.43v-1.25h1.51v-.7h3.92z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M191.35 599.91h105.01v3.07H191.35z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M191.35 599.91h105.01v3.07H191.35z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M188.14 599.35h4.47v27.02h-4.47zM299.44 626.37h-4.47v-27.02h4.47z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M188.14 599.35h4.47v27.02h-4.47zM299.44 626.37h-4.47v-27.02h4.47z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M191.35 599.91h105.01v.28H191.35z"
  }), React.createElement("circle", {
    cx: 190.11,
    cy: 601.59,
    r: 0.62,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 297.57,
    cy: 601.5,
    r: 0.62,
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M184.19 596.89l-1.01 1.14v.94h122.96v-.94l-.92-1.14H184.19z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M183.18 598.03h122.95v1.89H183.18zM493.84 549.02a10.28 10.28 0 0 0-1.34 2.54c-.09.22-.17.47-.25.71a2.6 2.6 0 0 0-.47-.16 6.77 6.77 0 0 0-2.11-.18v-.87c.09-3.12-.28-7.46-3.25-5.62s-.82 4.72 1 6.63l.47.46c-1.68 1.21-2 4-2.28 6.89s-2.74 6.08-4.38 7.89l-.46.5a6 6 0 0 0-4.76-1.22c-.07-.26-.14-.52-.22-.8-1.33-4.79-4.08-13.08-7.59-14.89.15-.19.31-.38.46-.59 1.5-2 3.17-4.84.69-5.59s-2.7 2.52-2.56 5c0 .31 0 .6.07.87a3.61 3.61 0 0 0-2.59 1.27l-.39-.46c-2-2.37-5.69-6.13-6.81-3.29-1 2.65 2.21 6.1 4.49 8.09l.14.12c-1.53 6.22 5.16 11.29 8.76 13.51l.47.29c-5 5.85-8 16.83-8 16.83l13.92 2.49s9.22-8 8-15.44h.1c9.22-1.85 11.32-11.68 9.88-17.52l.16-.06a10.53 10.53 0 0 0 4.27-3.23c2.64-3.64-2.77-7.69-5.42-4.17z"
  }), React.createElement("path", {
    d: "M493.84 549.02a10.28 10.28 0 0 0-1.34 2.54c-.09.22-.17.47-.25.71a2.6 2.6 0 0 0-.47-.16 6.77 6.77 0 0 0-2.11-.18v-.87c.09-3.12-.28-7.46-3.25-5.62s-.82 4.72 1 6.63l.47.46c-1.68 1.21-2 4-2.28 6.89s-2.74 6.08-4.38 7.89l-.46.5a6 6 0 0 0-4.76-1.22c-.07-.26-.14-.52-.22-.8-1.33-4.79-4.08-13.08-7.59-14.89.15-.19.31-.38.46-.59 1.5-2 3.17-4.84.69-5.59s-2.7 2.52-2.56 5c0 .31 0 .6.07.87a3.61 3.61 0 0 0-2.59 1.27l-.39-.46c-2-2.37-5.69-6.13-6.81-3.29-1 2.65 2.21 6.1 4.49 8.09l.14.12c-1.53 6.22 5.16 11.29 8.76 13.51l.47.29c-5 5.85-8 16.83-8 16.83l13.92 2.49s9.22-8 8-15.44h.1c9.22-1.85 11.32-11.68 9.88-17.52l.16-.06a10.53 10.53 0 0 0 4.27-3.23c2.64-3.64-2.77-7.69-5.42-4.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M466.14 553.03l-1.58 4.76s-.91-.64-2-1.64c-2.28-2-5.53-5.44-4.49-8.09 1.12-2.84 4.81.92 6.82 3.29.72.95 1.25 1.68 1.25 1.68zM469.56 550.31a22.25 22.25 0 0 1-1.59 1.87s-.2-1.13-.29-2.51c-.13-2.43.12-5.67 2.57-5s.82 3.69-.69 5.64zM490.56 551.06c-.05 1.57-.2 2.82-.2 2.82a20.52 20.52 0 0 1-2-1.81c-1.84-1.91-3.88-4.86-1-6.63s3.29 2.5 3.2 5.62zM500.17 553.12a10.47 10.47 0 0 1-4.27 3.23 13.71 13.71 0 0 1-1.43.52l-1.91-2.7a19.48 19.48 0 0 1 .79-2.61 10.28 10.28 0 0 1 1.34-2.54c2.65-3.52 8.06.53 5.48 4.1z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M464.8 551.35c.81 1 1.34 1.68 1.34 1.68l-1.58 4.76s-.91-.64-2-1.64a9.38 9.38 0 0 1 1.83-4.18c.07-.23.25-.43.41-.62zM469.56 550.31a22.25 22.25 0 0 1-1.59 1.87s-.2-1.13-.29-2.51a3.32 3.32 0 0 1 1.88.64z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M477.56 569.22l-4 1.78s-.89-.43-2.16-1.22c-4.25-2.61-12.8-9.2-7.07-17s10.52 6.16 12.4 13c.54 2.04.83 3.44.83 3.44z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M488.33 552.07a3.33 3.33 0 0 1 2.23-1c-.05 1.57-.2 2.82-.2 2.82a20.52 20.52 0 0 1-2.03-1.82zM495.9 556.35a13.71 13.71 0 0 1-1.43.52l-1.91-2.7a19.48 19.48 0 0 1 .79-2.61c1.21.72 2.15 2.52 2.55 4.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M485.86 573.93c-.22 0-.45.09-.68.12-13.57 2.06-4.48-5.26-4.48-5.26s.62-.56 1.44-1.48c1.64-1.81 4.1-5 4.38-7.89.43-4.4.92-8.52 6.11-7.31s6.07 19.25-6.77 21.82z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M476.7 565.79c.57 2 .88 3.43.88 3.43l-4 1.78s-.89-.43-2.16-1.22c1.54-2.01 3.33-3.53 5.28-3.99zM485.86 573.93c-.22 0-.45.09-.68.12-13.57 2.06-4.48-5.26-4.48-5.26s.62-.56 1.44-1.48a9 9 0 0 1 3.72 6.62z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M463.8 586.9s7.6-27.19 18.25-18.81-4.33 21.3-4.33 21.3z",
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 467.64,
    cy: 557.08,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 467.57,
    cy: 561.06,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 492.28,
    cy: 557.87,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 472.4,
    cy: 578.24,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 490.5,
    cy: 564.47,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 481.7,
    cy: 573.27,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 470.55,
    cy: 558.79,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 489.93,
    cy: 560.42,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 487.02,
    cy: 567.03,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 478.08,
    cy: 577.6,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 476.23,
    cy: 573.42,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 471.83,
    cy: 563.97,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 479.21,
    cy: 581.44,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 474.1,
    cy: 582.5,
    r: 0.85,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M346.4 604.82s15.8-31.73 22.85-33.11zM350.38 611.56s15.8-31.73 22.85-33.11zM353.83 618.56s15.79-31.74 22.84-33.11zM414.61 598.68s15.8-31.73 22.84-33.11zM418.56 605.37s15.8-31.73 22.84-33.11zM422.03 612.37s15.8-31.73 22.85-33.11zM620.16 566.76s15.79-31.73 22.84-33.1zM624.14 573.51s15.79-31.74 22.84-33.11zM627.56 580.5s15.79-31.73 22.84-33.1z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M365.68 611s-10.91-33.72-6.84-39.64zM427.69 607.26s-10.91-33.72-6.84-39.63zM627.56 585.34s-10.9-33.72-6.82-39.66z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M892.27 633.41s-13.84-24.51-34.71-31.58a42.61 42.61 0 0 1-21.58-16.15 71.25 71.25 0 0 1-6.37-11.46",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M817.28 570.45c2.37 2.31 13.43 4.69 13.43 4.69s-2.71-11-5.09-13.29a6 6 0 1 0-8.34 8.6zM822.76 589.55c3.25.65 13.83-3.37 13.83-3.37s-8.25-7.74-11.5-8.38a6 6 0 0 0-2.33 11.75zM845.56 611.06c3.13-1.08 10.24-9.89 10.24-9.89s-11-2.52-14.16-1.44a6 6 0 0 0 3.92 11.33zM866.44 623.45c3.27-.54 11.76-8 11.76-8s-10.44-4.35-13.71-3.81a6 6 0 1 0 2 11.82zM845.81 577.6c0 3.31-6 12.91-6 12.91s-6-9.59-6-12.9a6 6 0 1 1 12 0zM870.07 592.4c-1 3.16-9.58 10.53-9.58 10.53s-2.85-11-1.86-14.11a6 6 0 0 1 11.44 3.58zM891.68 610.03c-.45 3.28-7.66 12-7.66 12s-4.66-10.31-4.22-13.59a6 6 0 0 1 11.88 1.6z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M891.47 632.93s-2.71-28-18.91-42.93a42.69 42.69 0 0 1-13.2-23.53 71.6 71.6 0 0 1-1.18-13.06",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M848.03 545.5c1.24 3.07 10.39 9.74 10.39 9.74s2-11.15.73-14.22a6 6 0 0 0-11.12 4.48zM845.7 564.68c2.71 1.9 14 2.52 14 2.52s-4.4-10.42-7.1-12.32a6 6 0 0 0-6.9 9.8zM857.81 593.55c3.3.28 13.37-4.89 13.37-4.89s-9.07-6.77-12.36-7.05a6 6 0 1 0-1 11.94zM871.9 613.35c3.2.83 14-2.56 14-2.56s-7.79-8.21-11-9a6 6 0 1 0-3 11.6zM871.61 563.08c-1.34 3-10.7 9.37-10.7 9.37s-1.59-11.2-.25-14.23a6 6 0 1 1 10.95 4.86zM887.8 586.44c-2.19 2.49-13 5.74-13 5.74s1.83-11.16 4-13.65a6 6 0 0 1 9 7.91zM900.41 611.31c-1.73 2.82-11.86 7.86-11.86 7.86s-.09-11.32 1.65-14.14a6 6 0 1 1 10.21 6.28zM277.87 403.48s18.72-1.12 16.51 12a3.21 3.21 0 0 1-1.66 3.38s0-1-1.92-.65a8.46 8.46 0 0 1-2 .1 4.2 4.2 0 0 1-2.49-1s-5.26-2.17-7.31-10.77c0 0-1.51-1.88-1.45-2.36l3.16 1.35a5.69 5.69 0 0 0-.24 4.17s.11-4.09.71-4c.13 0 1.65.79 1.65.79s-1.86 4-.46 6.85c0 0-.53-4.89 1-6.56l2.22 1.29s-2.17 4.11-.7 7.45c0 0-.38-5.13 1.17-7.13l2 1.57s-2 4-.79 6.82c0 0 .16-6 1.23-6.43a12.39 12.39 0 0 1 2 2.2s-1.4 2.93-.53 4.48c0 0 .53-4 1-4a13.4 13.4 0 0 1 1.94 4.45 9.62 9.62 0 0 0-1.52-4.7 5.28 5.28 0 0 1 2.69 1.39s-.27-1.86-3.12-2a12.1 12.1 0 0 0-1.84-2.12 11.41 11.41 0 0 1 4.55.53s-1.51-1.76-5.07-1l-2-1.63s3.73-.51 5.32.06c0 0-1.83-1.56-5.85-.43l-2.17-1.29a19.48 19.48 0 0 1 5.08-.44s-2-1.08-5.72.09l-1.55-.7s2.34-.45 3-.53.72-.26.72-.26a8.14 8.14 0 0 0-4.38.49s-3.24-1.26-3.18-1.46zM368.5 364.29s18.72-1.13 16.51 12a3.2 3.2 0 0 1-1.66 3.37s0-1-1.92-.64a9.07 9.07 0 0 1-2 .09 4.22 4.22 0 0 1-2.48-1s-5.27-2.18-7.31-10.78c0 0-1.52-1.88-1.46-2.36l3.16 1.35a5.66 5.66 0 0 0-.23 4.17s.1-4.09.71-4c.12 0 1.64.79 1.64.79s-1.85 4-.45 6.86c0 0-.53-4.89 1-6.57l2.23 1.3s-2.17 4.1-.7 7.44c0 0-.38-5.13 1.16-7.13l2 1.57s-2 4.05-.8 6.82c0 0 .17-6 1.24-6.43a12.39 12.39 0 0 1 2 2.2s-1.4 2.93-.53 4.48c0 0 .53-4 1-4a13.4 13.4 0 0 1 1.94 4.45 9.62 9.62 0 0 0-1.52-4.7 5.28 5.28 0 0 1 2.69 1.39s-.27-1.86-3.12-2a12.1 12.1 0 0 0-1.84-2.12 11.62 11.62 0 0 1 4.55.53s-1.51-1.76-5.07-1l-2-1.63s3.73-.51 5.31.06c0 0-1.82-1.56-5.85-.42l-2.16-1.3a19.44 19.44 0 0 1 5.07-.44s-2-1.08-5.71.09l-1.55-.69s2.33-.46 3-.53.72-.26.72-.26a8.08 8.08 0 0 0-4.38.48 20.11 20.11 0 0 1-3.19-1.44zM429.28 219.76s18.73-1.13 16.52 12a3.2 3.2 0 0 1-1.66 3.37s0-1-1.92-.64a9.07 9.07 0 0 1-2 .09 4.25 4.25 0 0 1-2.49-1s-5.26-2.18-7.3-10.78c0 0-1.52-1.87-1.46-2.36l3.16 1.35a5.68 5.68 0 0 0-.23 4.18s.1-4.09.71-4c.12 0 1.64.79 1.64.79s-1.86 4-.45 6.86c0 0-.54-4.89 1-6.57l2.23 1.3s-2.17 4.1-.7 7.44c0 0-.38-5.13 1.16-7.13l2 1.58s-2 4-.8 6.81c0 0 .17-6 1.24-6.42a12.25 12.25 0 0 1 2 2.19s-1.4 2.93-.53 4.48c0 0 .53-4 1-4a13.18 13.18 0 0 1 1.94 4.45 9.55 9.55 0 0 0-1.51-4.7 5.28 5.28 0 0 1 2.69 1.39s-.27-1.86-3.12-2a13 13 0 0 0-1.84-2.13 11.62 11.62 0 0 1 4.55.53s-1.51-1.76-5.07-1l-2-1.62s3.73-.52 5.31.05c0 0-1.82-1.56-5.85-.42l-2.17-1.3a20 20 0 0 1 5.08-.44s-2-1.08-5.71.09l-1.55-.69s2.33-.46 3-.53.72-.26.72-.26a8.08 8.08 0 0 0-4.38.48 20.51 20.51 0 0 1-3.21-1.44zM483.79 177.27s18.72-1.13 16.52 12a3.21 3.21 0 0 1-1.67 3.37s0-1-1.92-.64a8.46 8.46 0 0 1-2 .1 4.26 4.26 0 0 1-2.49-1s-5.26-2.17-7.31-10.77c0 0-1.51-1.88-1.45-2.36l3.09 1.31a5.66 5.66 0 0 0-.23 4.17s.1-4.09.71-4c.12 0 1.64.79 1.64.79s-1.86 4-.46 6.85c0 0-.53-4.89 1-6.57l2.22 1.3s-2.17 4.1-.7 7.45c0 0-.37-5.13 1.17-7.13l2 1.57s-2 4-.8 6.82c0 0 .16-6 1.23-6.43a11.89 11.89 0 0 1 2 2.19s-1.39 2.94-.53 4.49c0 0 .54-4 1-4a13.1 13.1 0 0 1 1.94 4.44 9.55 9.55 0 0 0-1.51-4.7 5.25 5.25 0 0 1 2.69 1.4s-.28-1.87-3.13-2a12.1 12.1 0 0 0-1.84-2.12 11.58 11.58 0 0 1 4.56.52s-1.52-1.76-5.08-1l-1.88-1.64s3.74-.51 5.32 0c0 0-1.82-1.55-5.85-.42l-2.17-1.3a19.65 19.65 0 0 1 5.08-.43s-2-1.08-5.71.09l-1.55-.7s2.33-.46 3-.53.72-.26.72-.26a8 8 0 0 0-4.38.49s-3.28-1.14-3.23-1.35zM601.24 104.5s6.65 17.54-6.54 19.34a3.21 3.21 0 0 1-3.71-.59s.92-.32 0-2a8.3 8.3 0 0 1-.69-1.92 4.19 4.19 0 0 1 .26-2.65s.51-5.67 8.11-10.18c0 0 1.34-2 1.82-2.09l-.35 3.42a5.68 5.68 0 0 0-4.05 1s3.94-1.12 4-.51c0 .12-.26 1.8-.26 1.8s-4.34-.59-6.68 1.6c0 0 4.51-2 6.58-1l-.58 2.51s-4.56-.85-7.32 1.55c0 0 4.79-1.89 7.15-1l-.9 2.39s-4.46-.74-6.74 1.27c0 0 5.75-1.62 6.5-.73a12.37 12.37 0 0 1-1.49 2.59s-3.22-.46-4.44.82c0 0 4-.67 4.11-.26a13.25 13.25 0 0 1-3.67 3.17 9.58 9.58 0 0 0 4-2.84 5.3 5.3 0 0 1-.54 3s1.7-.81 1-3.58a12.14 12.14 0 0 0 1.48-2.39 11.51 11.51 0 0 1 .85 4.5s1.23-2-.59-5.13l1-2.38s1.6 3.41 1.53 5.09c0 0 .94-2.2-1.34-5.71l.6-2.45a19.38 19.38 0 0 1 1.92 4.71s.44-2.23-1.78-5.42l.2-1.69s1.13 2.09 1.41 2.72.46.61.46.61a8.06 8.06 0 0 0-1.77-4 20.11 20.11 0 0 1 .46-3.57zM941.81 412.97s18.72-1.13 16.51 12a3.2 3.2 0 0 1-1.66 3.37s0-1-1.92-.64a8.46 8.46 0 0 1-2 .1 4.26 4.26 0 0 1-2.49-1s-5.26-2.17-7.31-10.77c0 0-1.51-1.88-1.45-2.36l3.16 1.35a5.66 5.66 0 0 0-.23 4.17s.1-4.09.71-4c.12 0 1.64.79 1.64.79s-1.86 4-.46 6.85c0 0-.53-4.89 1-6.57l2.22 1.3s-2.17 4.1-.7 7.45c0 0-.38-5.13 1.17-7.13l2 1.57s-2 4-.79 6.82c0 0 .16-6 1.23-6.43a12.25 12.25 0 0 1 2 2.19s-1.39 2.94-.53 4.49c0 0 .53-4 1-4a13.1 13.1 0 0 1 1.94 4.44 9.67 9.67 0 0 0-1.51-4.7 5.37 5.37 0 0 1 2.69 1.4s-.28-1.87-3.13-2a12.1 12.1 0 0 0-1.84-2.12 11.58 11.58 0 0 1 4.56.52s-1.52-1.76-5.08-1l-2-1.62s3.73-.51 5.32.05c0 0-1.82-1.55-5.85-.42l-2.17-1.3a19.65 19.65 0 0 1 5.08-.43s-2-1.08-5.71.09l-1.55-.7s2.33-.46 3-.53.72-.26.72-.26a8 8 0 0 0-4.38.49s-3.25-1.25-3.19-1.46zM358.65 457.68s11.58 14.76-.47 20.4a3.2 3.2 0 0 1-3.72.55s.78-.58-.56-1.94a9 9 0 0 1-1.24-1.62 4.24 4.24 0 0 1-.57-2.63s-1.2-5.56 4.71-12.14c0 0 .68-2.31 1.11-2.54l.69 3.37a5.7 5.7 0 0 0-3.57 2.18s3.43-2.24 3.69-1.68c.06.11.29 1.8.29 1.8s-4.33.73-5.9 3.52c0 0 3.72-3.22 6-2.88l.2 2.56s-4.61.55-6.53 3.66c0 0 4-3.23 6.53-3.09l-.14 2.55s-4.49.62-6.06 3.22c0 0 5-3.26 6-2.64a11.91 11.91 0 0 1-.65 2.92s-3.2.52-4 2.11c0 0 3.57-1.82 3.83-1.47a13.27 13.27 0 0 1-2.55 4.12 9.61 9.61 0 0 0 3-3.92 5.33 5.33 0 0 1 .38 3s1.38-1.29-.11-3.73a12.26 12.26 0 0 0 .7-2.72 11.55 11.55 0 0 1 2.16 4s.58-2.25-2.1-4.72l.21-2.56s2.54 2.78 3 4.4c0 0 .25-2.38-3-5l-.17-2.52a19.86 19.86 0 0 1 3.25 3.93s-.25-2.26-3.33-4.65l-.3-1.67s1.7 1.66 2.14 2.18.63.44.63.44a8.08 8.08 0 0 0-2.89-3.32s-.86-3.41-.66-3.47zM956.64 348.52s11.58 14.76-.47 20.41a3.2 3.2 0 0 1-3.72.55s.78-.58-.56-1.95a9 9 0 0 1-1.24-1.62 4.21 4.21 0 0 1-.57-2.62s-1.2-5.57 4.71-12.15c0 0 .68-2.31 1.11-2.53l.69 3.36a5.68 5.68 0 0 0-3.57 2.19s3.43-2.24 3.69-1.69c.06.11.29 1.8.29 1.8s-4.32.73-5.9 3.52c0 0 3.72-3.22 6-2.88l.2 2.57s-4.61.54-6.53 3.66c0 0 4-3.23 6.53-3.1l-.14 2.55s-4.49.62-6.06 3.23c0 0 5-3.27 6-2.64a11.85 11.85 0 0 1-.65 2.91s-3.2.52-4 2.12c0 0 3.57-1.83 3.84-1.48a13.37 13.37 0 0 1-2.56 4.12 9.61 9.61 0 0 0 3-3.92 5.35 5.35 0 0 1 .38 3s1.38-1.29-.11-3.72a12.26 12.26 0 0 0 .7-2.72 11.46 11.46 0 0 1 2.16 4s.58-2.24-2.1-4.72l.21-2.56s2.54 2.78 3 4.4c0 0 .25-2.38-3-5.05l-.17-2.52a19.86 19.86 0 0 1 3.25 3.93s-.25-2.26-3.33-4.65l-.3-1.67s1.7 1.66 2.15 2.18.62.44.62.44a8.14 8.14 0 0 0-2.89-3.32s-.86-3.35-.66-3.43zM1005.56 451.09s2.2 18.63-11 17.17a3.2 3.2 0 0 1-3.46-1.47s1-.08.54-2a8.94 8.94 0 0 1-.22-2 4.25 4.25 0 0 1 .88-2.55s1.87-5.37 10.34-7.91c0 0 1.79-1.62 2.28-1.59l-1.17 3.24a5.68 5.68 0 0 0-4.18 0s4.09-.13 4 .48c0 .13-.7 1.69-.7 1.69s-4.07-1.63-6.87-.07c0 0 4.86-.81 6.62.66l-1.17 2.3s-4.22-1.93-7.47-.27c0 0 5.1-.67 7.18.75l-1.45 2.1s-4.15-1.8-6.85-.4c0 0 6-.18 6.48.86a12.5 12.5 0 0 1-2.07 2.16s-3-1.23-4.51-.28c0 0 4 .31 4.05.74a13.07 13.07 0 0 1-4.33 2.19 9.63 9.63 0 0 0 4.61-1.78 5.37 5.37 0 0 1-1.24 2.77s1.85-.38 1.85-3.24c0 0 1.91-1.56 2-2a11.59 11.59 0 0 1-.26 4.58s1.67-1.61.66-5.12l1.51-2.08s.72 3.7.25 5.31c0 0 1.45-1.91.09-5.87l1.17-2.23a20 20 0 0 1 .73 5s1-2.06-.42-5.7l.61-1.58s.59 2.3.7 3 .3.7.3.7a8 8 0 0 0-.74-4.34s1.01-3.27 1.26-3.22zM1048.15 586.83a11.08 11.08 0 0 0 3.6-5.44c.47-2.16-.45-4.75-2.52-5.54-2.31-.89-4.78.72-6.66 2.34s-4 3.46-6.47 3.12a9.85 9.85 0 0 0 3-9.22 4 4 0 0 0-.85-1.88c-1.29-1.37-3.61-.78-5.15.3-4.89 3.44-6.25 10.08-6.28 16.06-.49-2.16-.08-4.4-.09-6.62s-.62-4.66-2.49-5.85a7.51 7.51 0 0 0-3.78-.89c-2.2-.08-4.65.14-6.15 1.75-1.87 2-1.38 5.35.24 7.55s4.09 3.57 6.36 5.09a14.19 14.19 0 0 1 4.55 4.34 5 5 0 0 1 .34.77h13.77a38.55 38.55 0 0 0 8.58-5.88zM778.84 597.98a11 11 0 0 0 3.61-5.43c.46-2.17-.46-4.76-2.52-5.54-2.32-.89-4.79.71-6.66 2.33s-4 3.47-6.48 3.13a9.85 9.85 0 0 0 3-9.23 3.77 3.77 0 0 0-.85-1.87c-1.28-1.37-3.61-.78-5.14.3-4.89 3.44-6.26 10.08-6.28 16.06-.5-2.16-.08-4.41-.09-6.62s-.62-4.66-2.49-5.85a7.44 7.44 0 0 0-3.79-.89c-2.2-.08-4.64.14-6.14 1.75-1.87 2-1.39 5.34.24 7.54s4.09 3.58 6.36 5.1a14.27 14.27 0 0 1 4.55 4.33 4.57 4.57 0 0 1 .33.78h13.78a38.2 38.2 0 0 0 8.57-5.89zM188.14 529.68s4.26-.37 5.67.82c0 0-4.82 1.25-5.32 2.25 0 0 .1.1.5 0s2.94-.64 3.48 0l.18.31.19.12.28.19a1 1 0 0 1 .38.47c.09.28.31 0 .31 0s.32.66.22.84.31.63.31.63v2l.16-.15a8.92 8.92 0 0 0 .91 3.63s1.91 4.85 2.57 5.22h.4s2.88 3.82 5.64 4.63 2.91 1.66 2.91 1.66l-3.45 3.82a12.24 12.24 0 0 0-1.94.31 25.39 25.39 0 0 0 3.6.13l2.66-3.51a2.06 2.06 0 0 1 .91.47 1.81 1.81 0 0 1 .47.22c.22.16.38 0 .56.07s-1.41 2.75-1.41 2.75h-1.77l1.47.53c.5.19 1.53-.44 1.53-.44l1.41-2.56.57.5v-.35s.59.35.84.29-.31-.41-.31-.41a2.45 2.45 0 0 0 .84 0c.16-.09-.15-.6-.15-.6v-.37s-.93 0-.81-.19.46-.28 1.05 0 4.21 1.85 5.59 1.28a16.46 16.46 0 0 0 2.88 1.79c.68.16 1.47 1.34 1.47 1.34s2.91 3 4.63 2.26a7.47 7.47 0 0 1-.78-1.66c-.1-.53-2.23-2.25-2.23-2.25s4.51 1.06 4.51.75c0 0 2.25 1.28 2.38 1.28s0-.78-1.22-1.69l1.7.25a2 2 0 0 0-1.39-1.75 4.73 4.73 0 0 0-1.56-1.38l-7.05-3.91s.69-.35-.09-1.35a5.85 5.85 0 0 1 .66-.18c.4-.1-3.16-3.1-3.26-3.09a3.81 3.81 0 0 1-1.12-1.23c-.13-.38-3.35-2.26-3.35-2.26s-2.78-.19-4.69-4-6.45-4.23-6.45-4.23-1.63-8.07-9.33-5c-.08.06-5.35.34-6.16 1.75zM684.65 481.68c-.52.84-2.09.34-2.59 1.19a2.32 2.32 0 0 0 0 1.45 3.09 3.09 0 0 1-3.91 3.12 5.25 5.25 0 0 1-1.57 3.45 3.35 3.35 0 0 1-3.87-.21 7.26 7.26 0 0 1-2.29-3.4c-.59-1.57-1-3.35-2.37-4.36-.49-.37-1.06-.6-1.54-1a6.46 6.46 0 0 1-2-3.46 35.8 35.8 0 0 0-1.61-4.85 7.25 7.25 0 0 0-3.41-3.66c-1.45-.67-3.13-.63-4.64-1.16a13.38 13.38 0 0 1-3.14-1.74 20.82 20.82 0 0 0-3.94-2.37 11.3 11.3 0 0 1-2.32-1.32 3.29 3.29 0 0 1-1.8-2.91 9.16 9.16 0 0 0-1.29-3.18c-.68-1.26-1.29-2.48-.85-3.77s1.8-2.07 2.26-3.33a7.63 7.63 0 0 0 .17-2.66 2.78 2.78 0 0 1 1-2.39c1.17-.78 2.59.2 4 .59a3.08 3.08 0 0 0 1.53.1 12.74 12.74 0 0 0 1.32-.56c2.19-.88 4.66.71 5.88 2.71s1.7 4.38 2.75 6.48a5.23 5.23 0 0 0 1.63 2.06 2.46 2.46 0 0 0 2.5.29l1.2 2.69c.61 1.38 1.24 2.75 1.86 4.13.79 1.76 1.71 3.66 3.48 4.44.79.34 1.67.41 2.48.69a5.37 5.37 0 0 1 3.46 4 9.83 9.83 0 0 0 .32 1.8c.68 1.83 3 2.24 4.73 3.2a6.65 6.65 0 0 1 2.4 2.34 1.49 1.49 0 0 1 .17 1.6z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M684.65 481.68c-.52.84-2.09.34-2.59 1.19a2.32 2.32 0 0 0 0 1.45 3.09 3.09 0 0 1-3.91 3.12 5.25 5.25 0 0 1-1.57 3.45 3.35 3.35 0 0 1-3.87-.21 7.26 7.26 0 0 1-2.29-3.4c-.59-1.57-1-3.35-2.37-4.36-.49-.37-1.06-.6-1.54-1a6.46 6.46 0 0 1-2-3.46 35.8 35.8 0 0 0-1.61-4.85 7.25 7.25 0 0 0-3.41-3.66c-1.45-.67-3.13-.63-4.64-1.16a13.38 13.38 0 0 1-3.14-1.74 20.82 20.82 0 0 0-3.94-2.37 11.3 11.3 0 0 1-2.32-1.32 3.29 3.29 0 0 1-1.8-2.91 9.16 9.16 0 0 0-1.29-3.18c-.68-1.26-1.29-2.48-.85-3.77s1.8-2.07 2.26-3.33a7.63 7.63 0 0 0 .17-2.66 2.78 2.78 0 0 1 1-2.39c1.17-.78 2.59.2 4 .59a3.08 3.08 0 0 0 1.53.1 12.74 12.74 0 0 0 1.32-.56c2.19-.88 4.66.71 5.88 2.71s1.7 4.38 2.75 6.48a5.23 5.23 0 0 0 1.63 2.06 2.46 2.46 0 0 0 2.5.29l1.2 2.69c.61 1.38 1.24 2.75 1.86 4.13.79 1.76 1.71 3.66 3.48 4.44.79.34 1.67.41 2.48.69a5.37 5.37 0 0 1 3.46 4 9.83 9.83 0 0 0 .32 1.8c.68 1.83 3 2.24 4.73 3.2a6.65 6.65 0 0 1 2.4 2.34 1.49 1.49 0 0 1 .17 1.6z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M647.11 461.79s.89 1.79-1.74 1.83 1.69 11.66 1.69 11.66l4.37 5.57 5.43-2.94.31-8.1.41-4.9s-5.08-1.65-4.15-3.84-6.32.72-6.32.72z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M662.88 509.19s3.2 3.16 6.95-1l-2.88-3.05h-3.63z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M668.62 505.68a21.45 21.45 0 0 0 2.23 4.41c.94 1 2.41 8.1.45 7.3s-5.71-6.77-5.93-7.79a35.87 35.87 0 0 1-.31-3.92zM640.61 523.04l17.28.67-2.01-7.3-8.7-.18-6.57 6.81z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M646.26 535.11c-.41.76-.25 3.4-.07 5.34.12 1.24.25 2.19.25 2.19s-6.46 2-7.44.27a5.21 5.21 0 0 1-.41-2.12 42.12 42.12 0 0 1 .41-6.53s-.27-5.92-.4-6.5c0-.23-.14-1-.22-1.77-.11-1.18-.23-2.5-.23-2.5l8.82-4.68v2.22c-.06 4.24-.2 13.14-.71 14.08z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M646.66 576.32h-5.3l-.18-.21a3.66 3.66 0 0 1-.58-3.53 24.77 24.77 0 0 0 .89-6.2 2.82 2.82 0 0 0 .05-1.6 2.86 2.86 0 0 1-.09-1.47 3.6 3.6 0 0 0-.27-1 3.07 3.07 0 0 1 0-1.52 11.52 11.52 0 0 0-.45-2.81c-.4-1.15-3.34-14.92-2.63-16.57 0 0 6.24-1.07 8.6-.26l-.31 10.69s-1.12 3.2-.18 4.05 0 3.48 0 3.48-.14.49.66 2.13 0 2.41 0 2.41v3.16a6.79 6.79 0 0 0 .09 3.88c.82 1.73.01 5.32-.3 5.37zM658.9 535.11c-.41.76-.25 3.4-.07 5.34.12 1.24.25 2.19.25 2.19s-6.46 2-7.44.27a5.21 5.21 0 0 1-.41-2.12 42.12 42.12 0 0 1 .41-6.53s-.27-5.92-.4-6.5c-.07-.31-.2-3.29-.3-6-.08-2.28-.15-4.35-.15-4.35l8.82 1.37s0 3.88-.11 7.86-.27 7.86-.6 8.47z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M659.3 576.32H654l-.18-.21a3.66 3.66 0 0 1-.58-3.53 24.77 24.77 0 0 0 .89-6.2 2.82 2.82 0 0 0 0-1.6 2.86 2.86 0 0 1-.09-1.47 3.6 3.6 0 0 0-.27-1 3.07 3.07 0 0 1 0-1.52 11.52 11.52 0 0 0-.45-2.81c-.4-1.15-3.34-14.92-2.63-16.57 0 0 6.24-1.07 8.6-.26l-.31 10.69s-1.12 3.2-.18 4.05 0 3.48 0 3.48-.14.49.66 2.13 0 2.41 0 2.41v3.16a6.79 6.79 0 0 0 .09 3.88c.87 1.73.06 5.32-.25 5.37z",
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 650.36,
    cy: 457.54,
    r: 6.28,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 650.58,
    cy: 457.34,
    r: 6.28,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M657.97 484.83a26 26 0 0 0-.13 5.24c4.06 3.35 3.3 10.38 3.3 10.38s3.12 14.23 2.42 15.55 1.51 9.22 1.51 9.22a38.77 38.77 0 0 1-5.63.65 15.78 15.78 0 0 1-2-.06 3.16 3.16 0 0 1-2.42-1c-1.25-2.18-6.64-5.44-6.64-5.44s-3.4 2.05-6.58 3.91c-1 .6-2 1.18-2.86 1.66a5.26 5.26 0 0 1-2.23.61c-3.78.28-8.82-2.09-8-2.92 1-1 5.84-19 5.84-19s2.45-11.14 4.59-12.69a2.32 2.32 0 0 0 .8-1.12c.73-2-.49-5.3-.49-5.3s-6.9-8.51-6.59-9a12.39 12.39 0 0 0 .31-3.11s.85-4.15 1.33-6.15 4-2.5 5-2.32 3.56 0 4.54-.8 2.63.31 2.63.31l3.83 1.92 3.65-2.15s3.66.19 4 .68 5.12 1.42 5.12 1.42c2.45 1.65 2.36 9.49 2.36 9.49s-5.88 5.12-7.08 7.75a9.22 9.22 0 0 0-.58 2.27z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M664.35 473.68l1.33 1.07 1.38 12.43 1.39 12.5s.53 1.25 1 1.12.4 7.39.4 7.39-5.12-3.15-6.95 1l-1.43-10.07s-1.83-10.29-1.78-11.09-.94-9.49-.94-9.49zM633.88 474.26l-1 1.2s.09 5.17-.67 6.42 2.09 8.55 3.16 8.11 3.48-11.85 3.48-12-4.97-3.73-4.97-3.73z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M633.79 481.61s-3.12 3.16-2.9 4.68 3.21 6.27 7.49 3.72c0 0 3.96-7.46-4.59-8.4z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M646.56 576.33h-5.2l-.18-.21c1.13-.39 3.57-.97 5.38.21zM659.2 576.33H654l-.18-.21c1.13-.39 3.57-.97 5.38.21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M645.9 453.38a1.52 1.52 0 0 1 .6.06 2.41 2.41 0 0 1 .75.57 2.71 2.71 0 0 0 2.55.49 3.39 3.39 0 0 1 1-.28 1.5 1.5 0 0 1 1.22.81c.26.44.4.94.63 1.39a1.78 1.78 0 0 0 1.09 1 1.88 1.88 0 0 1 .68.16.91.91 0 0 1 .3.42c.42.9.75 2 1.64 2.41a2.51 2.51 0 0 0 1 .23 2.16 2.16 0 0 0 1.06-.2 2.11 2.11 0 0 0 .79-.78 4.87 4.87 0 0 0 .48-3.13 8.53 8.53 0 0 0-1.38-3.77 7.84 7.84 0 0 0-7.17-3.32 11.3 11.3 0 0 0-1.43.28 7.78 7.78 0 0 0-4.41 2.73 9 9 0 0 1-.82 1c.48-.02.95-.06 1.42-.07z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M645.9 453.38a1.52 1.52 0 0 1 .6.06 2.41 2.41 0 0 1 .75.57 2.71 2.71 0 0 0 2.55.49 3.39 3.39 0 0 1 1-.28 1.5 1.5 0 0 1 1.22.81c.26.44.4.94.63 1.39a1.78 1.78 0 0 0 1.09 1 1.88 1.88 0 0 1 .68.16.91.91 0 0 1 .3.42c.42.9.75 2 1.64 2.41a2.51 2.51 0 0 0 1 .23 2.16 2.16 0 0 0 1.06-.2 2.11 2.11 0 0 0 .79-.78 4.87 4.87 0 0 0 .48-3.13 8.53 8.53 0 0 0-1.38-3.77 7.84 7.84 0 0 0-7.17-3.32 11.3 11.3 0 0 0-1.43.28 7.78 7.78 0 0 0-4.41 2.73 9 9 0 0 1-.82 1c.48-.02.95-.06 1.42-.07zM639.09 468.34s.31 2.49-.76 3.11.76-3.11.76-3.11zM644.66 465.42s-3.77.24-3.79.78 3.79-.78 3.79-.78z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M665.68 459.53l-14 7.57-13.24 7.16-3.88-3.21 7.78-13.73 6.54-11.56a3 3 0 0 0 1.53.09 9.5 9.5 0 0 0 1.32-.56c2.19-.87 4.66.72 5.89 2.71s1.69 4.38 2.74 6.49a5.23 5.23 0 0 0 1.63 2.06 2.48 2.48 0 0 0 2.5.29z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("rect", {
    x: 633.99,
    y: 470.9,
    width: 4.73,
    height: 9.49,
    rx: 1.06,
    ry: 1.06,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 633.99,
    y: 470.9,
    width: 4.73,
    height: 9.49,
    rx: 1.06,
    ry: 1.06,
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 636.2,
    cy: 473.69,
    r: 0.71,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M634.05 485.68s.79-3.69-.26-4.86-.72-7.3.89-7.17 4 5 3.61 6-1.92 6.29-1.92 6.29z",
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 102.78,
    cy: 127.85,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 222.44,
    cy: 102.93,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 763.21,
    cy: 104.37,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 102.78,
    cy: 177.25,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 799.08,
    cy: 143.34,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 808.34,
    cy: 210.42,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 1031.39,
    cy: 132.38,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 357.93,
    cy: 81.37,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 889.29,
    cy: 92.87,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 782.57,
    cy: 280.42,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 221.31,
    cy: 326.07,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 797.96,
    cy: 291.75,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 1069.02,
    cy: 209.19,
    r: 1.12,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 317.35,
    cy: 166.3,
    r: 1.12,
    fill: "#fff"
  }));
};
UndrawBeforeDawn.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawBeforeDawn;